webpackJsonp([1],{

/***/ 167:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 172:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Editor_vue__ = __webpack_require__(71);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26d64c22_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Editor_vue__ = __webpack_require__(174);
function injectStyle (ssrContext) {
  __webpack_require__(173)
}
var normalizeComponent = __webpack_require__(15)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Editor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26d64c22_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Editor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 173:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 174:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editor"},[_c('div',{staticClass:"editor__toolbar"},[_c('div',{staticClass:"button"}),_vm._v(" "),_c('div',{staticClass:"button"}),_vm._v(" "),_c('div',{staticClass:"button",staticStyle:{"margin-right":"7px"}}),_vm._v("\n      "+_vm._s(_vm.title)+"\n   ")]),_vm._v(" "),_c('div',{staticClass:"editor__content",staticStyle:{"padding-top":"5px","padding-bottom":"5px"}},[_vm._l((_vm.lines),function(line,index){return [_c('div',{staticClass:"editor__line line"},[_c('span',{staticClass:"line__number line__number--symbol"},[_vm._v(_vm._s(index+1))]),_vm._v(_vm._s(line)+"\n         ")])]})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 45:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(46);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4051380b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(80);
function injectStyle (ssrContext) {
  __webpack_require__(78)
}
var normalizeComponent = __webpack_require__(15)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4051380b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4051380b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 46:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
   data: function data() {
      return {
         name: 'home'
      };
   }
});

/***/ }),

/***/ 47:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Info_vue__ = __webpack_require__(48);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2051f2d0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Info_vue__ = __webpack_require__(82);
function injectStyle (ssrContext) {
  __webpack_require__(81)
}
var normalizeComponent = __webpack_require__(15)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2051f2d0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Info_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2051f2d0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Info_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 48:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
   data: function data() {
      return {
         name: 'info'
      };
   }
});

/***/ }),

/***/ 49:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ 71:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
   props: {
      lines: {
         type: Array,
         required: false,
         default: []
      },
      title: {
         type: String,
         required: false,
         default: ''
      }
   }
});

/***/ }),

/***/ 72:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_amp_theme_index_css__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_amp_theme_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_amp_theme_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__agustinm_v_particles__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Home__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Info__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Editor__ = __webpack_require__(172);










__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5__agustinm_v_particles__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('home-component', __WEBPACK_IMPORTED_MODULE_6__components_Home__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('info-component', __WEBPACK_IMPORTED_MODULE_7__components_Info__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('editor-component', __WEBPACK_IMPORTED_MODULE_8__components_Editor__["a" /* default */]);

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
   el: '#app',
   router: __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */],
   template: '<App/>',
   components: {
      App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */]
   }
});

/***/ }),

/***/ 76:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Info__ = __webpack_require__(47);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
   routes: [{
      path: '/',
      name: 'home-page',
      component: __WEBPACK_IMPORTED_MODULE_2__components_Home__["a" /* default */]
   }, {
      path: '/docs',
      name: 'docs-page',
      component: __WEBPACK_IMPORTED_MODULE_3__components_Info__["a" /* default */]
   }, {
      path: '*',
      redirect: '/'
   }]
}));

/***/ }),

/***/ 78:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 80:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticStyle:{"display":"block","height":"100%"}},[_c('v-particles',{attrs:{"id":_vm.name,"color":['#a34242', '#2C405A'],"speed":0.4}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h3',{staticClass:"subtitle"},[_vm._v(" v1.2.9")])]),_vm._v(" "),_c('div',{staticStyle:{"padding":"0"},attrs:{"slot":"content"},slot:"content"},[_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('h1',{staticClass:"title",staticStyle:{"font-size":"62px","font-weight":"600","display":"flex"}},[_vm._v("vParticles")])]),_vm._v(" "),_c('el-row',{staticStyle:{"margin":"0"},attrs:{"type":"flex","justify":"center"}},[_c('h2',{staticClass:"subtitle",staticStyle:{"margin":"0"}},[_vm._v("Vue.js plugin for particle background")])]),_vm._v(" "),_c('el-row',{staticStyle:{"padding":"16px"},attrs:{"type":"flex","justify":"center"}},[_c('el-button',{staticStyle:{"font-size":"16px"},attrs:{"size":"large","type":"primary"},on:{"click":function($event){$event.stopPropagation();_vm.$router.push('/docs')}}},[_vm._v("Get\n                  started\n               ")])],1)],1)])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 81:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 82:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background-color":"#FAFBFC","padding-bottom":"32px"}},[_c('div',{staticStyle:{"display":"block","height":"300px"}},[_c('v-particles',{attrs:{"max-particles":50,"id":_vm.name,"color":['#a34242', '#2C405A', '#FAFBFC'],"speed":0.4}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h3',{staticClass:"subtitle"},[_vm._v(" v1.2.9")])]),_vm._v(" "),_c('div',{staticStyle:{"padding":"0"},attrs:{"slot":"content"},slot:"content"},[_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('h1',{staticClass:"title",staticStyle:{"font-size":"42px","font-weight":"600","display":"flex"}},[_vm._v("vParticles")])])],1)])],1),_vm._v(" "),_c('el-row',{staticStyle:{"margin-top":"-50px"},attrs:{"type":"flex","justify":"center","gutter":20}},[_c('el-col',{attrs:{"xs":24,"sm":24,"md":18,"lg":16,"xl":10}},[_c('el-card',[_c('h3',{staticClass:"subtitle2",staticStyle:{"margin":"0","width":"100px"}},[_vm._v("Installation")]),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"7px"}},[_vm._v("Npm installation:")]),_vm._v(" "),_c('editor-component',{attrs:{"title":"~terminal","lines":['npm i @agustinm/v-particles -S']}})],1),_vm._v(" "),_c('el-card',{staticStyle:{"margin-top":"16px"}},[_c('h3',{staticClass:"subtitle2",staticStyle:{"margin":"0","width":"53px"}},[_vm._v("Usage")]),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"7px"}},[_vm._v("Plugin declaration:")]),_vm._v(" "),_c('editor-component',{attrs:{"title":"~/src/main.js","lines":[
                  'import Vue from \'vue\';',
                  'import vParticles from \'@agustinm/v-particles\';',
                  'Vue.use(vParticles);'
                  ]}})],1),_vm._v(" "),_c('el-card',{staticStyle:{"margin-top":"16px"}},[_c('h3',{staticClass:"subtitle2",staticStyle:{"margin":"0","width":"80px"}},[_vm._v("Examples")]),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"7px"}},[_vm._v("Basic usage with default options:")]),_vm._v(" "),_c('editor-component',{staticStyle:{"margin-top":"7px"},attrs:{"title":"~/src/main.js","lines":['<v-particles></v-particles>']}}),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"7px"}},[_vm._v("With custom colors:")]),_vm._v(" "),_c('editor-component',{attrs:{"title":"~/src/main.js","lines":[
               '<v-particles color=\'#ffffff\'></v-particles>',
               '<v-particles :color=\'[\'#2C405A\', \'#FAFBFC\']\'></v-particles>'
            ]}}),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"7px"}},[_vm._v("Multiple instances")]),_vm._v(" "),_c('editor-component',{staticStyle:{"margin-top":"7px"},attrs:{"title":"~/src/main.js","lines":['<v-particles id=\'first-one\'></v-particles>',
                              '<v-particles id=\'second-one\'></v-particles>']}}),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"7px"}},[_vm._v("Every option can be applied the same way.")])],1),_vm._v(" "),_c('el-card',{staticStyle:{"margin-top":"16px"}},[_c('h3',{staticClass:"subtitle2",staticStyle:{"margin":"0","width":"70px"}},[_vm._v("Options")]),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"7px"}},[_vm._v("Customization options for v-particles")]),_vm._v(" "),_c('table',{staticClass:"el-table"},[_c('thead',[_c('tr',{staticStyle:{"font-size":"16px","color":"#2C405A"}},[_c('td',[_vm._v("Option name")]),_vm._v(" "),_c('td',[_vm._v("Type")]),_vm._v(" "),_c('td',[_vm._v("Default")]),_vm._v(" "),_c('td',[_vm._v("Description")])])]),_vm._v(" "),_c('tbody',{staticClass:"el-table__body",staticStyle:{"font-size":"16px","color":"black"}},[_c('tr',{staticClass:"el-table-"},[_c('td',[_c('strong',[_vm._v("background")])]),_vm._v(" "),_c('td',[_vm._v("String")]),_vm._v(" "),_c('td',[_vm._v("#FAFBFC")]),_vm._v(" "),_c('td',[_vm._v("Background color for particles container")])]),_vm._v(" "),_c('tr',[_c('td',[_c('strong',[_vm._v("color")])]),_vm._v(" "),_c('td',[_vm._v("String/Array")]),_vm._v(" "),_c('td',[_vm._v("#a34242")]),_vm._v(" "),_c('td',[_vm._v("Color, or colors for the particles")])]),_vm._v(" "),_c('tr',[_c('td',[_c('strong',[_vm._v("connectParticles")])]),_vm._v(" "),_c('td',[_vm._v("Boolean")]),_vm._v(" "),_c('td',[_vm._v("true")]),_vm._v(" "),_c('td',[_vm._v("Whether the particles should be connected or not")])]),_vm._v(" "),_c('tr',[_c('td',[_c('strong',[_vm._v("height")])]),_vm._v(" "),_c('td',[_vm._v("String")]),_vm._v(" "),_c('td',[_vm._v("inherit")]),_vm._v(" "),_c('td',[_vm._v("Height of the particles container")])]),_vm._v(" "),_c('tr',[_c('td',[_c('strong',[_vm._v("id")])]),_vm._v(" "),_c('td',[_vm._v("String")]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_vm._v("Unique identifier for the component instance")])]),_vm._v(" "),_c('tr',[_c('td',[_c('strong',[_vm._v("maxParticles")])]),_vm._v(" "),_c('td',[_vm._v("Number")]),_vm._v(" "),_c('td',[_vm._v("127")]),_vm._v(" "),_c('td',[_vm._v("Number of particles to display")])]),_vm._v(" "),_c('tr',[_c('td',[_c('strong',[_vm._v("minDistance")])]),_vm._v(" "),_c('td',[_vm._v("Number")]),_vm._v(" "),_c('td',[_vm._v("93")]),_vm._v(" "),_c('td',[_vm._v("Minimum distance between particles")])]),_vm._v(" "),_c('tr',[_c('td',[_c('strong',[_vm._v("responsive")])]),_vm._v(" "),_c('td',[_vm._v("Array")]),_vm._v(" "),_c('td',[_vm._v("(See below)")]),_vm._v(" "),_c('td',[_vm._v("Array with responsive configuration")])]),_vm._v(" "),_c('tr',[_c('td',[_c('strong',[_vm._v("speed")])]),_vm._v(" "),_c('td',[_vm._v("Number")]),_vm._v(" "),_c('td',[_vm._v("0.5")]),_vm._v(" "),_c('td',[_vm._v("Number specifying particles speed(1 = 100%, 1.1 = 110%, ...).")])]),_vm._v(" "),_c('tr',[_c('td',[_c('strong',[_vm._v("sizeVariations")])]),_vm._v(" "),_c('td',[_vm._v("Number")]),_vm._v(" "),_c('td',[_vm._v("4")]),_vm._v(" "),_c('td',[_vm._v("Amount of different particles sizes")])]),_vm._v(" "),_c('tr',[_c('td',[_c('strong',[_vm._v("scaleWidth")])]),_vm._v(" "),_c('td',[_vm._v("Number")]),_vm._v(" "),_c('td',[_vm._v("1")]),_vm._v(" "),_c('td',[_vm._v("Width scale of the container")])]),_vm._v(" "),_c('tr',[_c('td',[_c('strong',[_vm._v("scaleHeight")])]),_vm._v(" "),_c('td',[_vm._v("Number")]),_vm._v(" "),_c('td',[_vm._v("1")]),_vm._v(" "),_c('td',[_vm._v("Height scale of the container")])])])])]),_vm._v(" "),_c('el-card',{staticStyle:{"margin-top":"16px"}},[_c('h3',{staticClass:"subtitle2",staticStyle:{"margin":"0","width":"97px"}},[_vm._v("Responsive")]),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"7px"}},[_vm._v("With vParticles you can configure how the plugin will look based on the\n               screen size:")]),_vm._v(" "),_c('div',{staticClass:"editor"},[_c('div',{staticClass:"editor__toolbar"},[_c('div',{staticClass:"button"}),_vm._v(" "),_c('div',{staticClass:"button"}),_vm._v(" "),_c('div',{staticClass:"button",staticStyle:{"margin-right":"7px"}}),_vm._v("\n                  ~your-component.vue\n               ")]),_vm._v(" "),_c('div',{staticClass:"editor__content",staticStyle:{"padding-top":"5px","padding-bottom":"5px"}},[_c('div',{staticClass:"editor__line line"},[_c('span',{staticClass:"line__number"},[_vm._v("8")]),_vm._v("   responsive: [\n                  ")]),_vm._v(" "),_c('div',{staticClass:"editor__line line"},[_c('span',{staticClass:"line__number"},[_vm._v("9")]),_vm._v("     {\n                  ")]),_vm._v(" "),_c('div',{staticClass:"editor__line line"},[_c('span',{staticClass:"line__number"},[_vm._v("10")]),_vm._v("       breakpoint: "),_c('span',{staticClass:"editor__value"},[_vm._v("768")]),_vm._v(",\n                  ")]),_vm._v(" "),_c('div',{staticClass:"editor__line line"},[_c('span',{staticClass:"line__number"},[_vm._v("11")]),_vm._v("       options: {\n                  ")]),_vm._v(" "),_c('div',{staticClass:"editor__line line"},[_c('span',{staticClass:"line__number"},[_vm._v("12")]),_vm._v("         maxParticles: "),_c('span',{staticClass:"editor__value"},[_vm._v("200")]),_vm._v(",\n                  ")]),_vm._v(" "),_c('div',{staticClass:"editor__line line"},[_c('span',{staticClass:"line__number"},[_vm._v("13")]),_vm._v("         color: "),_c('span',{staticClass:"editor__value"},[_vm._v("'#48F2E3'")]),_vm._v(",\n                  ")]),_vm._v(" "),_c('div',{staticClass:"editor__line line"},[_c('span',{staticClass:"line__number"},[_vm._v("14")]),_vm._v("         connectParticles: "),_c('span',{staticClass:"editor__value"},[_vm._v("false")])]),_vm._v(" "),_c('div',{staticClass:"editor__line line"},[_c('span',{staticClass:"line__number"},[_vm._v("15")]),_vm._v("       }\n                  ")]),_vm._v(" "),_c('div',{staticClass:"editor__line line"},[_c('span',{staticClass:"line__number"},[_vm._v("16")]),_vm._v("     }, {\n                  ")]),_vm._v(" "),_c('div',{staticClass:"editor__line line"},[_c('span',{staticClass:"line__number"},[_vm._v("17")]),_vm._v("       breakpoint: "),_c('span',{staticClass:"editor__value"},[_vm._v("425")]),_vm._v(",\n                  ")]),_vm._v(" "),_c('div',{staticClass:"editor__line line"},[_c('span',{staticClass:"line__number"},[_vm._v("18")]),_vm._v("       options: {\n                  ")]),_vm._v(" "),_c('div',{staticClass:"editor__line line"},[_c('span',{staticClass:"line__number"},[_vm._v("19")]),_vm._v("         maxParticles: "),_c('span',{staticClass:"editor__value"},[_vm._v("100")]),_vm._v(",\n                  ")]),_vm._v(" "),_c('div',{staticClass:"editor__line line"},[_c('span',{staticClass:"line__number"},[_vm._v("20")]),_vm._v("         connectParticles: "),_c('span',{staticClass:"editor__value"},[_vm._v("true")])]),_vm._v(" "),_c('div',{staticClass:"editor__line line"},[_c('span',{staticClass:"line__number"},[_vm._v("21")]),_vm._v("       }\n                  ")]),_vm._v(" "),_c('div',{staticClass:"editor__line line"},[_c('span',{staticClass:"line__number"},[_vm._v("22")]),_vm._v("     }, {\n                  ")]),_vm._v(" "),_c('div',{staticClass:"editor__line line"},[_c('span',{staticClass:"line__number"},[_vm._v("23")]),_vm._v("       breakpoint: "),_c('span',{staticClass:"editor__value"},[_vm._v("320")]),_vm._v(",\n                  ")]),_vm._v(" "),_c('div',{staticClass:"editor__line line"},[_c('span',{staticClass:"line__number"},[_vm._v("24")]),_vm._v("       options: {\n                  ")]),_vm._v(" "),_c('div',{staticClass:"editor__line line"},[_c('span',{staticClass:"line__number"},[_vm._v("25")]),_vm._v("         maxParticles: "),_c('span',{staticClass:"editor__value"},[_vm._v("0")]),_vm._v(" "),_c('span',{staticClass:"editor__comment"},[_vm._v("// disables particles.js")])]),_vm._v(" "),_c('div',{staticClass:"editor__line line"},[_c('span',{staticClass:"line__number"},[_vm._v("26")]),_vm._v("       }\n                  ")]),_vm._v(" "),_c('div',{staticClass:"editor__line line"},[_c('span',{staticClass:"line__number"},[_vm._v("27")]),_vm._v("     }\n                  ")]),_vm._v(" "),_c('div',{staticClass:"editor__line line"},[_c('span',{staticClass:"line__number"},[_vm._v("28")]),_vm._v("   ]\n                  ")])])]),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"7px"}},[_vm._v("The \"responsive\" prop consists of an object array specifying a\n               breakpoint for each object, and an \"options\" object where you can set options specifically for each\n               screen size.")])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 83:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(49);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f0c42cc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(85);
function injectStyle (ssrContext) {
  __webpack_require__(84)
}
var normalizeComponent = __webpack_require__(15)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f0c42cc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 84:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 85:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},[72]);


// WEBPACK FOOTER //
// main.eedc8a68edc4c31a9822.js